import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { canonicalWorkspacePath } from "../../utils/workspacePaths.mjs";

// # WORKSPACES: los enlaces guardados conservan filtros, detalle y destino de login.
export default function LegacyWorkspaceRedirect() {
  const location = useLocation();
  const path = canonicalWorkspacePath(location.pathname);
  if (path === "/owner" && /\/almacenamiento\/?$/.test(location.pathname)) {
    const search = new URLSearchParams(location.search);
    search.set("vista", "database");
    return <Navigate to={`${path}?${search}${location.hash}`} replace />;
  }
  return <Navigate to={`${path}${location.search}${location.hash}`} replace />;
}
